import todosMutations from "./todos.mutation";
import todosStates from "./todos.state";
import todosActions from "./todos.action";
import todosGetters from "./todos.getters";

export default {
  mutations: todosMutations,
  state: todosStates,
  actions: todosActions,
  getters: todosGetters
};
